module.exports = __webpack_public_path__ + "static/media/icon-tick.870e6e86.svg";